// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} AccountConfiguration
 * @property {string} id
 * @property {Object.<string,any>} emr
 */

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} PersonalDetails
 * @property {string} id
 * @property {string} email
 * @property {string} picURL
 * @property {string} sex
 * @property {number} dateOfBirth
 * @property {number} age - virtual of dateOfBirth
 * @property {Object} name
 * @property {string} name.firstName
 * @property {string} name.middleName
 * @property {string} name.lastName
 */

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} Account
 * @property {string} uid
 * @property {string} email
 * @property {string} picURL
 * @property {string} sex
 * @property {number} dateOfBirth
 * @property {number} age - virtual of dateOfBirth
 * @property {Object} name
 * @property {string} name.firstName
 * @property {string} name.middleName
 * @property {string} name.lastName
 * @property {PersonalDetails} [personalDetails] not initially populated
 * @property {AccountConfiguration} [accountConfig] not initially populated
 */

const state = {
  /** @type {Object.<string,Account>} */
  accounts: {}
};

export default state;
